import { useTranslations } from "next-intl";
import { BounceLoader } from "@/components/common/bounce-loader";
import { getLocalePrice } from "@/lib/utilities";
import { cn } from "@/lib/utils";

type SummaryDayPriceRowProps = {
  days: number;
  dailyPrice: number;
  total: number;
  // Colours the per-day price as promotional. The regular price is carried by
  // a separate struck-through row, so the discount is signalled by colour only.
  discounted?: boolean;
  loading?: boolean;
  // Padding is left to the caller: the configuration aside renders this row as
  // a standalone card row, the checkout sidebar nests it inside a padded
  // product block.
  className?: string;
};

// "N days × price per day" on the left, position total on the right (DS
// itemDayPrice). Shared by the diet configuration aside and the checkout
// sidebar so both price the position the same way.
export const SummaryDayPriceRow = ({
  days,
  dailyPrice,
  total,
  discounted = false,
  loading = false,
  className,
}: SummaryDayPriceRowProps) => {
  const t = useTranslations();

  return (
    <div
      className={cn(
        "flex items-center justify-between gap-2 text-base",
        className,
      )}
    >
      <span className="flex items-center gap-1 text-brand-green1-300">
        {t("common.days", { count: days })} ×{" "}
        {loading ? (
          <BounceLoader className="h-4" />
        ) : (
          <span
            className={cn(
              "font-bold",
              discounted ? "text-brand-red" : "text-brand-green1-300",
            )}
          >
            {getLocalePrice({ price: dailyPrice })}
          </span>
        )}
      </span>
      <span className="font-bold text-brand-green1-300">
        {loading ? (
          <BounceLoader className="h-4" />
        ) : (
          getLocalePrice({ price: total })
        )}
      </span>
    </div>
  );
};
